import React from 'react';
import { ZapIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { toneAt } from '../utils/iconTones';
export function ProblemSection() {
  return <section className="w-full bg-cream-100 px-6 py-10 sm:py-12" aria-labelledby="problem-title" data-id="element-135" data-mp="30h7mfrl9vyvm">
      <div className="mx-auto max-w-5xl text-center" data-id="element-136" data-mp="2vqhimishw431">
        <h2 id="problem-title" className="mx-auto max-w-3xl font-display text-3xl font-bold uppercase leading-[1.08] tracking-tight text-forest-800 sm:text-4xl lg:text-[2.75rem]" data-id="element-137" data-mp="2vowm4nmmeb2j">
          Do you lack the structure to teach without improvising?
        </h2>

        <p className="mx-auto mt-4 max-w-3xl text-base leading-relaxed text-forest-700/85 sm:text-lg" data-id="element-138" data-mp="3jeqxt1v7dtl7">
          You know the clinical content of Surgical Technology, but every academic cycle turns into hours of
          searching, building lessons from scratch, and doubting what to include, how to assess it, or how to
          connect it with the current OR reality.
        </p>

        <p className="mx-auto mt-4 flex max-w-2xl items-start justify-center gap-3 rounded-2xl bg-cream-200/70 px-6 py-3.5 text-base font-medium text-forest-800" data-id="element-139" data-mp="jdwnb50h6102">
          <ZapIcon className="mt-1 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-140" data-mp="sdtf3fi5vfzc" />
          <span data-id="element-141" data-mp="sbyu616w3nv9">That is not a knowledge problem. It is a system problem.</span>
        </p>

        <h3 className="mt-6 text-base font-medium text-forest-700/85" data-id="element-142" data-mp="x6mm6a13r0el">
          If you are a Surgical Technology Instructor, you’ve likely experienced this:
        </h3>

        <ul className="mt-4 grid gap-3 text-left sm:grid-cols-2" data-id="element-143" data-mp="171efv2rkd343">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }, index) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/60 bg-white p-5 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-card" data-id="element-144" data-mp="1g3dz81q1wja7" data-mpi={index}>
              <h4 className="flex items-center gap-3 text-[0.95rem] font-semibold tracking-wide" data-id="element-145" data-mp="3hvipl8rwj8it">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${toneAt(index).bg}`} data-id="element-146" data-mp="p121093biznp">
                  <Icon className={`h-[1.25rem] w-[1.25rem] ${toneAt(index).fg}`} strokeWidth={2} aria-hidden="true" data-id="element-147" data-mp="y1qdv0gz6tz0" />
                </span>
                <span className={toneAt(index).fg} data-id="element-148" data-mp="17xa7thbzbil4">{title}</span>
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-forest-600/90" data-id="element-149" data-mp="12z8r3320zvct">{description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}